export class Resource {
  id!: string;
  loading = false;
  selected = false;
  classes = '';
  [key: string]: any;
}
